(() => {
  if (window.dawnClearCartInitialized) return;
  window.dawnClearCartInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-clear-cart]');

    if (!button || button.dataset.loading === 'true') return;

    event.preventDefault();

    const confirmMessage = button.dataset.confirmMessage;
    if (confirmMessage && !window.confirm(confirmMessage)) return;

    const wrapper = button.closest('.cart__clear-wrapper');
    const errorMessage = wrapper?.querySelector('[data-clear-cart-error]');
    const buttonLabel = button.querySelector('[data-clear-cart-label]');
    const originalLabel = buttonLabel?.textContent;
    const loadingLabel = button.dataset.loadingLabel || originalLabel;
    const root = window.Shopify?.routes?.root || '/';

    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    if (buttonLabel && loadingLabel) buttonLabel.textContent = loadingLabel;
    if (errorMessage) errorMessage.hidden = true;

    try {
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error(`Clear cart failed: ${response.status}`);

      await response.json();
      window.location.assign(`${root}cart`);
    } catch (error) {
      console.error(error);

      button.dataset.loading = 'false';
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');

      if (buttonLabel && originalLabel) buttonLabel.textContent = originalLabel;
      if (errorMessage) errorMessage.hidden = false;
    }
  });
})();